import React from "react";
import AutocompleteInput from "../../common/AutocompleteInput";
import FadeOutErrorMessage from "../../common/FadeOutErrorMessage";

export default class CampusSearch extends React.PureComponent {
  state = {
    error: false,
    loading: true,
    seller: null,
  };

  searchSellers = async (searchValue) => {
    this.setState({
      seller: null,
    });

    const sellers = this.props.sellerList.sellers
      .filter((seller) => this.sellerMatchIndex(seller, searchValue) >= 0)
      .sort(
        (s1, s2) =>
          this.sellerMatchIndex(s1, searchValue) -
          this.sellerMatchIndex(s2, searchValue)
      );

    return sellers;
  };

  sellerMatchIndex = (seller, searchValue) => {
    return seller.value
      .toLowerCase()
      .trim()
      .indexOf(searchValue.toLowerCase().trim());
  };

  selectSeller = (seller) => {
    this.setState({ seller });
  };

  render() {
    const {
      sellerList: { error, loading },
    } = this.props;
    const { seller } = this.state;

    return (
      <div className="campus-search">
        <p className="fs-50 fw-700 text-center mb-32">Find a Campus</p>
        <p className="fs-18 fw-700 text-center mb-40">
          Find the Chabad on Campus to which you would like to make your
          donation and purchase tickets.
        </p>
        <div className="search-input">
          <div className="flex flex-align-center" style={{ flex: 1 }}>
            <i className="material-icons mr-8">search</i>
            <AutocompleteInput
              getSearchResults={this.searchSellers}
              selectSearchResult={this.selectSeller}
            />
            {loading && <span>Loading Campuses...</span>}
          </div>

          {!!seller && (
            <div
              className="flex flex-justify-center flex-align-center full-height pointer"
              style={{ width: "10%" }}
              onClick={() =>
                !!seller && this.props.goToRaffleByCampus(seller.slug)
              }
            >
              <p className="fw-700 brand-color-text">GO</p>
            </div>
          )}

          {error && (
            <FadeOutErrorMessage
              message="Sorry, something went wrong and we could not search Chabad Campuses for your keyword.  Please try again."
              onTimeout={() =>
                this.setState({
                  error: false,
                })
              }
            />
          )}
        </div>
      </div>
    );
  }
}
